import { Badge } from "@/components/ui/badge";
import { formatPhoneForDisplay } from "@/utils/phoneFormat";

export default function ContactItem({ contact, selected, onClick }) {
  const isActive = selected?.id === contact.id;
  const hasUnread = contact.unread_count > 0;
  const lastMsg = contact.last_message || "";
  const timeStr = contact.last_message_at
    ? new Date(contact.last_message_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    : "";

  return (
    <div
      className={`px-4 py-3 cursor-pointer border-b border-gray-100 transition-colors ${
        isActive ? "bg-emerald-50 border-l-4 border-l-emerald-500" : "hover:bg-gray-50"
      }`}
      onClick={onClick}
      data-testid={`contact-${contact.phone}`}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
          <span className="text-sm font-bold text-gray-500">
            {(contact.name || contact.phone || "?").charAt(0).toUpperCase()}
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <p className="font-medium text-sm truncate">{contact.name || formatPhoneForDisplay(contact.phone, "ContactItem")}</p>
            <span className="text-[10px] text-gray-400 flex-shrink-0">{timeStr}</span>
          </div>
          <p className="text-xs text-gray-400 truncate">{lastMsg}</p>
        </div>
        {hasUnread && (
          <Badge className="bg-emerald-500 text-white text-[10px] px-1.5 py-0.5">
            {contact.unread_count}
          </Badge>
        )}
      </div>
    </div>
  );
}
